import React, { useState, useEffect } from 'react';
import './App.css';
import { Routes } from './Config/routes';
import AOS from "aos";
function App() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        AOS.init();
        window.addEventListener('beforeunload', () => {
            setIsLoading(true);
        })

        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000)

        return () => {
            window.removeEventListener('beforeunload', () => {
                setIsLoading(true);
            })
            clearTimeout(timer);
        };
    }, [])

    return (
        <div>
            {isLoading ? (
                <div className="loader-container">
                    <div className="loader">
                    </div>
                </div>
            ) : (
                <Routes />
            )}
        </div>
    );
}

export default App;